<template>
  <div class="col-lg-12 gameResultContainer" :class="{movesAward: goodMoves, timesAward: goodTime, startAnimation: startAnimation}">
    <h1>Well done!</h1>   
    <div v-if="goodMoves" class="awardDetailsHolder awardDetailsHolder--moves">
      <div class="awardImage">
        <img class="moveAward" src="../../assets/images/games/award_moves.png">
      </div>
      <div class="awardText">
        <p class="moveAward" v-if="gameName == 'jump'">{{ attemptsWords }}</p>
        <p class="moveAward" v-else>{{ movesWords }}</p>
      </div>
    </div>
    <div v-if="goodTime" class="awardDetailsHolder awardDetailsHolder--times">
      <div class="awardImage">
        <img class="timeAward" src="../../assets/images/games/award_time.png">
      </div>
      <div class="awardText">
        <p class="timeAward">{{ timeWords }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['gameName', 'goodMoves', 'goodTime'],
  data() {
    return {
      startAnimation: false,
      calcedWidth: 0,
      movesWords: 'You did this in the least amount of moves',
      attemptsWords: 'You did this in the least amount of moves',
      timeWords: 'You did this in record time',
    }
  },
  mounted () {
    setTimeout(() => {
      this.startAnimation = true
    }, 400);
    this.animate()
  },
  computed: {
    gameResult () {
      return this.$store.getters.StoreGameData[this.gameData.gameName]
    }
  },
  methods: {
    animate () {
      let animationTime = 2000

      if (this.goodMoves) {
        animationTime += 2000
      }
      if (this.goodTime) {
        animationTime += 2000
      }

      setTimeout(() => {
        this.nextPage()
      }, animationTime);
    },
    nextPage () {
      this.$emit('nextPage')
    }
  }
}
</script>
